// extracted by mini-css-extract-plugin
export default {"payPalModeSection":"x8-z"};